<div id="st-mobile-search-mobile-search-overlay" class="mobile-search-overlay" #overlayRef>
  <div id="st-mobile-search-header" class="header d-flex justify-content-between">
    <div id="st-mobile-search-block" class="d-flex gap-3">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9127 16.034L9.15532 10.2766C8.69699 10.655 8.1699 10.9512 7.57407 11.1651C6.97824 11.3789 6.36184 11.4859 5.72488 11.4859C4.15814 11.4859 2.83217 10.9434 1.74696 9.85849C0.661746 8.77355 0.119141 7.44792 0.119141 5.8816C0.119141 4.31526 0.661609 2.98914 1.74655 1.90324C2.83148 0.817356 4.15712 0.274414 5.72346 0.274414C7.28978 0.274414 8.61589 0.817021 9.70179 1.90223C10.7877 2.98744 11.3306 4.31342 11.3306 5.88015C11.3306 6.53474 11.2208 7.15996 11.001 7.75579C10.7812 8.35162 10.488 8.86989 10.1213 9.31059L15.8787 15.068L14.9127 16.034ZM5.72488 10.1109C6.90597 10.1109 7.90638 9.70108 8.72609 8.88137C9.5458 8.06165 9.95566 7.06125 9.95566 5.88015C9.95566 4.69906 9.5458 3.69865 8.72609 2.87894C7.90638 2.05923 6.90597 1.64937 5.72488 1.64937C4.54378 1.64937 3.54338 2.05923 2.72367 2.87894C1.90397 3.69865 1.49412 4.69906 1.49412 5.88015C1.49412 7.06125 1.90397 8.06165 2.72367 8.88137C3.54338 9.70108 4.54378 10.1109 5.72488 10.1109Z"
          fill="var(--st-tertiary-color)"
        />
      </svg>
      <p class="f_14 f_600 clr_black">{{'search' | translate}}</p>
    </div>
    <button type="button" (click)="close()" (keydown.enter)="close()" (keydown.space)="$event.preventDefault(); close()"><img src="../../../../assets/icons_svg/search_cross.svg" alt="" /></button>
  </div>

  <div id="st-mobile-search-searchinput" class="searchInput d-flex align-items-center mt-4">
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9127 16.034L9.15532 10.2766C8.69699 10.655 8.1699 10.9512 7.57407 11.1651C6.97824 11.3789 6.36184 11.4859 5.72488 11.4859C4.15814 11.4859 2.83217 10.9434 1.74696 9.85849C0.661746 8.77355 0.119141 7.44792 0.119141 5.8816C0.119141 4.31526 0.661609 2.98914 1.74655 1.90324C2.83148 0.817356 4.15712 0.274414 5.72346 0.274414C7.28978 0.274414 8.61589 0.817021 9.70179 1.90223C10.7877 2.98744 11.3306 4.31342 11.3306 5.88015C11.3306 6.53474 11.2208 7.15996 11.001 7.75579C10.7812 8.35162 10.488 8.86989 10.1213 9.31059L15.8787 15.068L14.9127 16.034ZM5.72488 10.1109C6.90597 10.1109 7.90638 9.70108 8.72609 8.88137C9.5458 8.06165 9.95566 7.06125 9.95566 5.88015C9.95566 4.69906 9.5458 3.69865 8.72609 2.87894C7.90638 2.05923 6.90597 1.64937 5.72488 1.64937C4.54378 1.64937 3.54338 2.05923 2.72367 2.87894C1.90397 3.69865 1.49412 4.69906 1.49412 5.88015C1.49412 7.06125 1.90397 8.06165 2.72367 8.88137C3.54338 9.70108 4.54378 10.1109 5.72488 10.1109Z"
        fill="var(--st-tertiary-color)"
      />
    </svg>

    <input
      style="padding-left: 0.5rem"
      type="text"
      [(ngModel)]="searchQuery"
      (input)="onTyping(searchQuery)"
      (keyup)="onEnter($event)"
      autofocus
      [placeholder]="('search' | translate) + '...'"
    />
  </div>
</div>
